export function format(template: string, ...args: (string | number)[]): string {
  return template.replaceAll(/\{(\d+)\}/g, (match1, index) => {
    const argIndex = Number.parseInt(index, 10);
    return argIndex < args.length ? String(args[argIndex]) : match1;
  });
}

export function formatObject(
  template: string,
  formatObject?: Record<string, string | number | boolean | null | undefined>,
): string {
  if (formatObject == null) {
    return template;
  }
  return template.replaceAll(/\{(\w+)\}/g, (match, key) => {
    return formatObject[key] !== undefined ? String(formatObject[key]) : match;
  });
}
